export default "__VITE_ASSET__lHgeElJe__"